import PackageGroupMainPage from "./pages/PackageGroupMainPage";

export const packageGroupRoutes = (prefix = "package-group") => [
  {
    name: "PackageGroupMainPage",
    component: PackageGroupMainPage,
    path: prefix
  },
  {
    name: "PackageGroupMainDetailPage",
    component: PackageGroupMainPage,
    path: `${prefix}/:id`
  },
]